export default {"src":"https://js-static.iimjobs.com/production/17.1.2/_next/static/media/dot.eb2fa8db.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};